export default function ProgressBar({ done, total, className = '' }) {
  const pct = total > 0 ? Math.round((done / total) * 100) : 0;
  const color = pct >= 80 ? 'bg-teal-500' : pct >= 40 ? 'bg-ocean-500' : 'bg-ocean-400';
  return (
    <div className={`space-y-1 ${className}`}>
      <div className="flex justify-between items-baseline">
        <span className="text-xs text-gray-500 font-mono">
          <span className="dive-value">{done}</span>
          <span className="text-gray-400"> / {total}</span>
        </span>
        <span className="text-xs font-mono font-semibold text-ocean-600">{pct} %</span>
      </div>
      <div className="h-2 rounded-full bg-ocean-100 overflow-hidden">
        <div
          className={`h-full rounded-full transition-all duration-500 ${color}`}
          style={{ width: `${pct}%`, background: pct > 0 ? 'linear-gradient(90deg, #0ea5e9, #06b6d4)' : undefined }}
        />
      </div>
    </div>
  );
}
